import { Container } from '@pixi/react'
import { memo, useEffect, useRef } from 'react'
import { Container as PixiContainer } from 'pixi.js'
import { appScreen } from '@slot-nx/core'
import { spinService } from '../domain/game'

const width = 990
const height = 825

export const SlotDisplay = memo(() => {
  const x = (appScreen.width - width) / 2
  const y = 375

  const slotDisplayRef = useRef<PixiContainer>()

  useEffect(() => {
    spinService.initDisplayReels(slotDisplayRef.current as PixiContainer)
  }, [])

  return (
    <Container>
      <Container
        name="SlotDisplay"
        width={width}
        height={height}
        position={[x, y]}
        ref={(el) => {
          slotDisplayRef.current = el as PixiContainer
        }}
      >
      </Container>
    </Container>
  )
})
